export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_AUTH_FAIL = "SET_AUTH_FAIL";
export const SET_ITEMS = "SET_ITEMS";
